module.exports = __webpack_public_path__ + "static/img/icon-finished.4b29f335.png";